import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from '@Core/services/proprietary/app.service';

@Component({
    standalone: false,
    selector: 'ep-city-select-dialog',
    templateUrl: './city-select-dialog.component.html'
})
export class CitySelectDialogComponent {
    @Input() options: string[];
    @Input() county: string[];
    @Input() state: string[];

    constructor(private activeModal: NgbActiveModal, public app: AppService) { }

    public onSelect(city: string) {
        this.activeModal.close(city);
    }

    public cancelSelection() {
        this.activeModal.close();
    }
}
